<button
  class="pwi-pill pwi-pill--button pwi-pill--compact connectivity-chip"
  [class.connectivity-chip--offline]="!network.isOnline()"
  type="button"
  [matMenuTriggerFor]="connectivityMenu"
  [attr.aria-label]="network.isOnline() ? 'Connection status: online' : 'Connection status: offline'">
  <sara-icon
    [icon]="network.isOnline() ? 'wifi' : 'wifi-slash'"
    variant="solid"></sara-icon>
  @if (!network.isOnline()) {
    <!-- EF-1.2 "explicite hors-ligne": the chip grows a label offline — it
         absorbed the former full-width banner (removed 2026-08-18). role=status
         inherits the banner's screen-reader announcement of the transition.
         B3 (EF-4.2): once the vault serves content, the label carries the
         capture time of the stalest serve — no stale data shown as current. -->
    <span
      class="connectivity-chip__label"
      role="status">
      {{ offlineLabel() }}
    </span>
  }
</button>

<mat-menu
  #connectivityMenu="matMenu"
  class="connectivity-menu">
  <!-- Plain content, not menu items — taps on the rows shouldn't close the
       panel; Escape / outside-tap dismiss as usual. -->
  <div
    class="connectivity-details"
    role="region"
    aria-label="Connection details">
    <div class="connectivity-details__row">
      <span class="connectivity-details__label">Status</span>
      <span class="connectivity-details__value">{{ network.isOnline() ? 'Online' : 'Offline' }}</span>
    </div>
    <div class="connectivity-details__row">
      <span class="connectivity-details__label">Last server contact</span>
      <span class="connectivity-details__value">{{ lastContactLabel() }}</span>
    </div>
    @if (servedDataLabel(); as served) {
      <div class="connectivity-details__row">
        <span class="connectivity-details__label">Showing data captured</span>
        <span class="connectivity-details__value">{{ served }}</span>
      </div>
    }
    <div class="connectivity-details__row">
      <span class="connectivity-details__label">Actions waiting to sync</span>
      <span class="connectivity-details__value">{{ pendingActions }}</span>
    </div>
  </div>
</mat-menu>
